module.exports = __webpack_public_path__ + "img/background.dc2ff0c3.png";